export default "__VITE_PUBLIC_ASSET__59d3ca90__"